export default __webpack_public_path__ + "static/media/ant4.a9935ada.jpg";